// extracted by mini-css-extract-plugin
export default {"wrapper":"modal-core_wrapper__+IQAH","wrapper__opened":"modal-core_wrapper__opened__5seeB"};